import React from 'react'
import { Select, Row, Col, Button} from 'antd'
import moment from 'moment'
import './filter-month.scss'

const { Option } = Select

export default ({selectedYear, selectedMonth, on_year_change, on_month_change}) => {

    let months = []
    months = moment.months()

    return (
    <div>
        <Row type='flex' gutter={20} justify='space-between' align='middle' className='filter-month-container'>
            <Col span={4}>
                <div className='select-box'>
                    <Select
                        value = {selectedYear ? selectedYear : null} dropdownMatchSelectWidth={false}
                        onSelect={on_year_change}>
                        <Option key="0" value={null}>
                            Select Year
                        </Option>
                        <Option key="2017" value="2017">
                            2017
                        </Option>
                        <Option key="2018" value="2018">
                            2018
                        </Option>
                    </Select>
                </div>
            </Col>
            <Col span={4}>
                <div className='select-box'>
                    <Select
                        value = {selectedMonth ? selectedMonth : null} dropdownMatchSelectWidth={false}
                        onSelect={on_month_change}>
                        <Option key="0" value={null}>
                            Select Month
                        </Option>
                        {months.map((month, index) =>
                        <Option key={index + 1} value={index + 1}>
                            {month}
                        </Option>
                        )}
                    </Select>
                </div>
            </Col>
            <Col span={16}>
                <Button className="btn-filter" type='primary' size="large" htmlType='button'>Clear Filter</Button>
            </Col>
        </Row>
    </div>
)}

